module.exports = __webpack_public_path__ + "img/pos_quan_ly_don.38060e65.png";